/**
 * Format of responses from server with multiple values.
 */
export interface SubjectLicensePackBriefDetailContract {
  license_title: string;
  toleration_to: string | null;
  valid_from: string | null;
  valid_to: string | null;
}
